import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-4 mb-3" }
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = {
  key: 0,
  class: "col-md-4 mb-3"
}
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = {
  key: 1,
  class: "col-md-4 mb-3"
}
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = { class: "col-md-4" }
const _hoisted_11 = { class: "form-group mb-3" }
const _hoisted_12 = { class: "col-md-4" }
const _hoisted_13 = { class: "form-group mb-3" }
const _hoisted_14 = { class: "col-md-4 mb-3" }
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = ["onUpdate:modelValue"]
const _hoisted_17 = { class: "row mb-2" }
const _hoisted_18 = { class: "border border-primary mb-10" }
const _hoisted_19 = {
  class: "row d-flex align-items-center justify-content-between fw-bold py-2",
  style: {"background-color":"#0a59a4"}
}
const _hoisted_20 = { class: "col-md-5" }
const _hoisted_21 = { class: "d-flex float-end" }
const _hoisted_22 = ["disabled"]
const _hoisted_23 = { class: "col-md-4 mb-2" }
const _hoisted_24 = { class: "form-group" }
const _hoisted_25 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_26 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_27 = { class: "col-md-4 mb-2" }
const _hoisted_28 = { class: "form-group" }
const _hoisted_29 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_30 = { class: "col-md-4 mb-2" }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = {
  key: 2,
  class: "row"
}
const _hoisted_33 = { class: "border border-primary mb-10" }
const _hoisted_34 = { class: "row d-flex align-items-center justify-content-between fw-bold py-2 bg-primary" }
const _hoisted_35 = { class: "col-md-5" }
const _hoisted_36 = { class: "d-flex float-end" }
const _hoisted_37 = ["disabled"]
const _hoisted_38 = { class: "row" }
const _hoisted_39 = { class: "col-md-7 mb-2" }
const _hoisted_40 = { class: "form-group" }
const _hoisted_41 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_42 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_43 = { class: "col-md-2 mb-2" }
const _hoisted_44 = { class: "form-group" }
const _hoisted_45 = ["onUpdate:modelValue"]
const _hoisted_46 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_47 = { class: "col-md-2 mb-2" }
const _hoisted_48 = { class: "form-group" }
const _hoisted_49 = ["onUpdate:modelValue"]
const _hoisted_50 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_51 = { class: "col-md-1 mb-2" }
const _hoisted_52 = ["onClick"]
const _hoisted_53 = { class: "col-md-12 mt-3" }
const _hoisted_54 = { class: "d-flex align-items-center" }
const _hoisted_55 = ["disabled"]
const _hoisted_56 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Form, {
        onSubmit: _ctx.addInventaire,
        "validation-schema": _ctx.inventaireSchema,
        "keep-values": _ctx.valuess
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _cache[9] || (_cache[9] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Type d'inventaire "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Multiselect, {
                  searchable: true,
                  options: ['Global', 'Partiel'],
                  modelValue: _ctx.typeInventaire,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.typeInventaire) = $event)),
                  placeholder: "Sélectionner le type d'inventaire"
                }, null, 8, ["modelValue"])
              ])
            ]),
            (_ctx.typeInventaire == 'Partiel')
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _cache[10] || (_cache[10] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                      _createTextVNode(" Magasin "),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1)),
                    _createVNode(_component_Multiselect, {
                      options: _ctx.magasinOptions,
                      searchable: true,
                      "track-by": "label",
                      label: "label",
                      modelValue: _ctx.magasin,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.magasin) = $event)),
                      placeholder: "Sélectionner le magasin",
                      onSelect: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectMag(_ctx.magasin)))
                    }, null, 8, ["options", "modelValue"])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.typeInventaire == 'Partiel')
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _cache[11] || (_cache[11] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Inventaire Global ", -1)),
                    _createVNode(_component_Field, {
                      modelValue: _ctx.inventaireGlobal,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.inventaireGlobal) = $event)),
                      name: "inventaireGlobal"
                    }, {
                      default: _withCtx(({ field }) => [
                        _createVNode(_component_Multiselect, _mergeProps({
                          options: _ctx.inventaireOptions,
                          searchable: true,
                          "track-by": "label",
                          label: "label",
                          modelValue: field.value,
                          "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                        }, field, { placeholder: "Sélectionner un inventaire" }), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "inventaireGlobal",
                      class: "text-danger"
                    })
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _cache[12] || (_cache[12] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Date de début "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  name: "dateDebut",
                  min: _ctx.minDate,
                  type: "datetime-local",
                  modelValue: _ctx.dateDebut,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dateDebut) = $event)),
                  class: "form-control shadow-none fs-md-15 text-black"
                }, null, 8, ["min", "modelValue"])
              ]),
              _createVNode(_component_ErrorMessage, {
                name: "dateDebut",
                class: "text-danger"
              })
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _cache[13] || (_cache[13] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Date de fin "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  name: "dateFin",
                  min: _ctx.dateDebut,
                  type: "datetime-local",
                  modelValue: _ctx.dateFin,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.dateFin) = $event)),
                  class: "form-control shadow-none fs-md-15 text-black"
                }, null, 8, ["min", "modelValue"])
              ]),
              _createVNode(_component_ErrorMessage, {
                name: "dateFin",
                class: "text-danger"
              })
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _cache[14] || (_cache[14] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Motif ", -1)),
                _createVNode(_component_Field, {
                  name: "motif",
                  as: "textarea",
                  cols: "15",
                  rows: "1",
                  placeholder: "Entrer le motif",
                  class: "form-control shadow-none rounded-0 text-black"
                }, {
                  default: _withCtx(({ field }) => [
                    _withDirectives(_createElementVNode("textarea", {
                      class: "form-control shadow-none rounded-0 text-black",
                      cols: "1",
                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                    }, null, 8, _hoisted_16), [
                      [_vModelText, field.value]
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "motif",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _cache[16] || (_cache[16] = _createElementVNode("div", { class: "col-md-7" }, [
                    _createElementVNode("h3", { class: "fs-4 text-white" }, " Equipes de l'inventaire ")
                  ], -1)),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("button", {
                        class: _normalizeClass(["default-btn me-20 transition border-0 fw-medium text-white pt-2 pb-2 ps-8 pe-8 rounded-1 fs-md-13 fs-lg-14 bg-success", { 'cursor-not-allowed': _ctx.isDisables }]),
                        type: "button",
                        disabled: _ctx.isDisables,
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.addRowEquipe()))
                      }, _cache[15] || (_cache[15] = [
                        _createElementVNode("i", { class: "fa fa-plus-circle position-relative ms-5 fs-12" }, null, -1),
                        _createTextVNode(" Ajouter une equipe ")
                      ]), 10, _hoisted_22),
                      _createVNode(_component_router_link, { to: "/liste-mouvements" })
                    ])
                  ])
                ]),
                _createElementVNode("div", null, [
                  _cache[18] || (_cache[18] = _createElementVNode("div", { class: "row d-flex align-items-center justify-content-between mt-10" }, [
                    _createElementVNode("div", { class: "col-md-4" }, [
                      _createElementVNode("div", { class: "form-group mb-15 mb-sm-20 mb-md-25" }, [
                        _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                          _createTextVNode(" Personnels "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ])
                      ])
                    ]),
                    _createElementVNode("div", { class: "col-md-4" }, [
                      _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                        _createTextVNode(" Role"),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ])
                    ]),
                    _createElementVNode("div", { class: "col-md-4" }, [
                      _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Actions ")
                    ])
                  ], -1)),
                  _cache[19] || (_cache[19] = _createElementVNode("hr", { class: "mt-0" }, null, -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.equipes, (equipe, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "row",
                      key: index
                    }, [
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, [
                          _createVNode(_component_Multiselect, {
                            options: _ctx.personnelOptions,
                            searchable: true,
                            multiple: false,
                            modelValue: equipe.user,
                            "onUpdate:modelValue": ($event: any) => ((equipe.user) = $event),
                            disabledProp: "disabled",
                            placeholder: "Sélectionner le personnel"
                          }, null, 8, ["options", "modelValue", "onUpdate:modelValue"]),
                          (_ctx.valideteRowEquipe(equipe.user))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_25))
                            : _createCommentVNode("", true),
                          (_ctx.validateDupliacatEquipe(equipe.user))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_26, "Ce personnel a déjà été selectionné"))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("div", _hoisted_28, [
                          _createVNode(_component_Multiselect, {
                            options: _ctx.roleOptions,
                            searchable: true,
                            multiple: false,
                            modelValue: equipe.role,
                            "onUpdate:modelValue": ($event: any) => ((equipe.role) = $event),
                            placeholder: "Choisir le role"
                          }, null, 8, ["options", "modelValue", "onUpdate:modelValue"]),
                          (_ctx.valideteRowEquipe(equipe.role))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_29))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("button", {
                          class: "btn btn-danger transition border-0 pb-2 ps-8 pe-8",
                          type: "button",
                          onClick: ($event: any) => (_ctx.removeRowEquipe(index))
                        }, _cache[17] || (_cache[17] = [
                          _createElementVNode("i", { class: "fa fa-trash-o lh-1 me-1 position-relative top-2" }, null, -1)
                        ]), 8, _hoisted_31)
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ]),
            (_ctx.typeInventaire == 'Partiel')
              ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, [
                      _cache[21] || (_cache[21] = _createElementVNode("div", { class: "col-md-7" }, [
                        _createElementVNode("h4", { class: "fs-4 text-white" }, "Produits")
                      ], -1)),
                      _createElementVNode("div", _hoisted_35, [
                        _createElementVNode("div", _hoisted_36, [
                          _createElementVNode("button", {
                            class: _normalizeClass(["default-btn me-20 transition border-0 fw-medium text-white pt-2 pb-2 ps-8 pe-8 rounded-1 fs-md-13 fs-lg-14 bg-success", { 'cursor-not-allowed': _ctx.isDisable }]),
                            type: "button",
                            disabled: _ctx.isDisable,
                            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.addRowProduit()))
                          }, _cache[20] || (_cache[20] = [
                            _createElementVNode("i", { class: "fa fa-plus-circle position-relative ms-5 fs-12" }, null, -1),
                            _createTextVNode("Ajouter un produit ")
                          ]), 10, _hoisted_37)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_38, [
                        _cache[23] || (_cache[23] = _createElementVNode("div", { class: "row mt-10" }, [
                          _createElementVNode("div", { class: "col-md-7" }, [
                            _createElementVNode("label", { class: "d-block text-black fw-semibold" }, [
                              _createTextVNode(" Produit "),
                              _createElementVNode("span", { class: "text-danger" }, "*")
                            ])
                          ]),
                          _createElementVNode("div", { class: "col-md-2" }, [
                            _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Stock Logique ")
                          ]),
                          _createElementVNode("div", { class: "col-md-2" }, [
                            _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Stock Fiche ")
                          ]),
                          _createElementVNode("div", { class: "col-md-1" }, [
                            _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Action ")
                          ]),
                          _createElementVNode("hr", { class: "mt-0" })
                        ], -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.produits, (produit, produitIndex) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "row gx-2 gy-0",
                            key: produitIndex
                          }, [
                            _createElementVNode("div", _hoisted_39, [
                              _createElementVNode("div", _hoisted_40, [
                                _createVNode(_component_Multiselect, {
                                  options: _ctx.produitOptions,
                                  searchable: true,
                                  "track-by": "label",
                                  label: "label",
                                  disabled: _ctx.isDis,
                                  modelValue: produit.produit,
                                  "onUpdate:modelValue": ($event: any) => ((produit.produit) = $event),
                                  placeholder: "Sélectionner le produit",
                                  onSelect: ($event: any) => (_ctx.selectProd(produit.produit, produit,produitIndex))
                                }, null, 8, ["options", "disabled", "modelValue", "onUpdate:modelValue", "onSelect"]),
                                (_ctx.validateRowProduit(produit.produit))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_41, " Le produit est obligatoire. "))
                                  : _createCommentVNode("", true),
                                (_ctx.validateDupliacatProduit(produit.produit))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_42, " Ce produit a été déja selectionné "))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_43, [
                              _createElementVNode("div", _hoisted_44, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "number",
                                  "onUpdate:modelValue": ($event: any) => ((produit.qtiteLogique) = $event),
                                  class: _normalizeClass(
                              _ctx.validateRowProduit(produit.qtiteLogique)
                                ? 'form-control shadow-none fs-md-15 text-black is-invalid '
                                : 'form-control shadow-none fs-md-15 text-black'),
                                  placeholder: "Entrer la quantité"
                                }, null, 10, _hoisted_45), [
                                  [_vModelText, produit.qtiteLogique]
                                ]),
                                (_ctx.validateRowProduit(produit.qtiteLogique))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_46, " La quantité est obligatoire. "))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_47, [
                              _createElementVNode("div", _hoisted_48, [
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": ($event: any) => ((produit.qtiteFiche) = $event),
                                  type: "number",
                                  class: _normalizeClass(
                                _ctx.validateRowProduit(produit.qtiteFiche)
                                ? 'form-control shadow-none fs-md-15 text-black is-invalid'
                                : 'form-control shadow-none fs-md-15 text-black'),
                                  placeholder: "Entrer la quantité"
                                }, null, 10, _hoisted_49), [
                                  [_vModelText, produit.qtiteFiche]
                                ]),
                                (_ctx.validateRowProduit(produit.qtiteFiche))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_50, " La quantité est obligatoire. "))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_51, [
                              _createElementVNode("button", {
                                class: "btn btn-danger transition border-0 pb-2 ps-8 pe-8",
                                type: "button",
                                onClick: ($event: any) => (_ctx.removeRowProduit(produitIndex))
                              }, _cache[22] || (_cache[22] = [
                                _createElementVNode("i", { class: "fa fa-trash-o lh-1 me-1 position-relative top-2" }, null, -1)
                              ]), 8, _hoisted_52)
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_53, [
              _createElementVNode("div", _hoisted_54, [
                _createElementVNode("button", {
                  class: _normalizeClass(["btn btn-success me-3", { 'cursor-not-allowed': (_ctx.typeInventaire=='Global')? _ctx.isDisables:_ctx.isDisable }]),
                  type: "submit",
                  ref: "submitButton",
                  disabled: (_ctx.typeInventaire=='Global')? _ctx.isDisables:_ctx.isDisable
                }, " Enregistrer ", 10, _hoisted_55),
                _createElementVNode("button", {
                  class: _normalizeClass(["btn btn-primary me-3", { 'cursor-not-allowed': _ctx.isDisable }]),
                  type: "button",
                  disabled: _ctx.isDisable,
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.Soumettre()))
                }, " Enregistrer et Soumettre ", 10, _hoisted_56),
                _createVNode(_component_router_link, {
                  to: "/inventaires/liste-fiche-inventaires",
                  class: "btn btn-danger"
                }, {
                  default: _withCtx(() => _cache[24] || (_cache[24] = [
                    _createElementVNode("i", { class: "fa fa-trash-o lh-1 me-1 position-relative top-2" }, null, -1),
                    _createElementVNode("span", { class: "position-relative" }, null, -1),
                    _createTextVNode("Annuler")
                  ])),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema", "keep-values"])
    ])
  ]))
}